import { SelectField, SelectFieldProps } from "@homebound/beam";
import { useGlobalPlanTaskSelectQuery } from "src/components/autoPopulateSelects/GlobalPlanTaskSelectField.generated";
import { NamedFragment } from "src/fragments/commonFragments.generated";
import { GlobalPlanTaskFilter } from "src/generated/graphqlTypes";

type GlobalPlanTaskSelectFieldProps = Omit<
  SelectFieldProps<NamedFragment, string>,
  "options" | "multiselect" | "getOptionLabel" | "getOptionValue"
> & {
  filter?: GlobalPlanTaskFilter;
};

export function GlobalPlanTaskSelectField(props: GlobalPlanTaskSelectFieldProps) {
  const { placeholder = "Select a Task", filter = {}, ...otherProps } = props;
  const { data, loading } = useGlobalPlanTaskSelectQuery({
    fetchPolicy: "cache-first",
    variables: { filter: filter },
  });

  return (
    <SelectField
      {...otherProps}
      placeholder={loading ? "Loading..." : placeholder}
      options={data?.globalPlanTasks.entities ?? []}
    />
  );
}
